export default "__VITE_ASSET__ChkMIv$C__"